import { Column, Header, Text } from '@mattilsynet/mt-ui';
import React from 'react';
import { IPrivatAdresse } from '../types';
interface IPrivatPersonAdresseInfoProps {
  tittel: string;
  adresse: IPrivatAdresse;
}
export const PrivatPersonAdresseInfo = ({
  tittel,
  adresse
}: IPrivatPersonAdresseInfoProps) => <Column justify={'flex-start'} align={'flex-start'} spacing={1} data-sentry-element="Column" data-sentry-component="PrivatPersonAdresseInfo" data-sentry-source-file="PrivatPersonAdresseInfo.tsx">
    <Header as="h3" size="normal" data-sentry-element="Header" data-sentry-source-file="PrivatPersonAdresseInfo.tsx">
      {tittel}
    </Header>
    <Column data-sentry-element="Column" data-sentry-source-file="PrivatPersonAdresseInfo.tsx">
      <Text textAlign="left" data-sentry-element="Text" data-sentry-source-file="PrivatPersonAdresseInfo.tsx">{adresse.gateadresse}</Text>
    </Column>
    <Column data-sentry-element="Column" data-sentry-source-file="PrivatPersonAdresseInfo.tsx">
      <Text data-sentry-element="Text" data-sentry-source-file="PrivatPersonAdresseInfo.tsx">{`${adresse.postNr || ''} ${adresse.poststed || ''}`}</Text>
    </Column>
  </Column>;